import { utils } from "../../../utils/utils_general";
import { LOCAL_STORAGE } from "../../../constants/localStorage";

export function clearReloadState() {
  utils.remove_local_storage(LOCAL_STORAGE.SIGNUP_DESTINATION);
}
